const adjustSvgDimensions = (svgString: string, svgScaleValue: number) => {
  const parser = new DOMParser();
  const doc = parser.parseFromString(svgString, 'image/svg+xml');
  const svgElement = doc.querySelector('svg');

  if (svgElement) {
    const widthAttr = svgElement.getAttribute('width');
    const heightAttr = svgElement.getAttribute('height');

    if (widthAttr?.endsWith('pt')) {
      const widthInPt = parseFloat(widthAttr);
      const widthInPx = (widthInPt / 0.75) * svgScaleValue;
      svgElement.setAttribute('width', `${widthInPx}px`);
    } else if (widthAttr?.endsWith('in')) {
      const widthInInch = parseFloat(widthAttr);
      const widthInPx = widthInInch * 96 * svgScaleValue;
      svgElement.setAttribute('width', `${widthInPx}px`);
    }

    if (heightAttr?.endsWith('pt')) {
      const heightInPt = parseFloat(heightAttr);
      const heightInPx = (heightInPt / 0.75) * svgScaleValue;
      svgElement.setAttribute('height', `${heightInPx}px`);
    } else if (heightAttr?.endsWith('in')) {
      const heightInInch = parseFloat(heightAttr);
      const heightInPx = heightInInch * 96 * svgScaleValue;
      svgElement.setAttribute('height', `${heightInPx}px`);
    }
  }

  const serializer = new XMLSerializer();
  return serializer.serializeToString(doc);
};

export { adjustSvgDimensions };
